import { createStore } from '@cobuildlab/react-simple-state';
import { DeleteUserDialogStore, UserChangeStatusDialogStore } from './user-types';


export const userChangeStatusDialogStore = createStore<UserChangeStatusDialogStore>({
  initialValue: {
    open: false,
    user: undefined,
  },
});



export const deleteUserDialogStore = createStore<DeleteUserDialogStore>({
  initialValue: {
    open: false,
    user: undefined,
  },
});


